// Unpublished Work © 2022-2024 Deere & Company.

export const SECONDS_PER_MINUTE = 60;
export const MILLISECONDS_PER_SECOND = 1000;
export const MILLISECONDS_PER_MINUTE = SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;
export const MINUTES_PER_HOUR = SECONDS_PER_MINUTE;
export const THIRTY_DAYS = 30;
